import { compare, random, capitalize as _capitalize, chunk as _chunk, count as _count, hyphenate as _hyphenate, truncate as _truncate, bytes as _bytes, chars as _chars, words as _words, lines as _lines, trim as _trim, trimEnd as _trimEnd, trimStart as _trimStart, stripEnd as _stripEnd, stripStart as _stripStart, dedent as _dedent, byteLength as _byteLength, isAscii as _isAscii, isEmoji as _isEmoji, } from "../string.ts";
String.compare = compare;
String.random = random;
if (typeof String.dedent === "undefined") {
    String.dedent = _dedent;
}
String.prototype.count = function count(sub) {
    return _count(String(this), sub);
};
String.prototype.capitalize = function capitalize(all) {
    return _capitalize(String(this), all);
};
String.prototype.hyphenate = function capitalize() {
    return _hyphenate(String(this));
};
String.prototype.bytes = function bytes() {
    return _bytes(String(this));
};
String.prototype.chars = function chars() {
    return _chars(String(this));
};
String.prototype.words = function words() {
    return _words(String(this));
};
String.prototype.lines = function lines() {
    return _lines(String(this));
};
String.prototype.chunk = function chunk(length) {
    return _chunk(String(this), length);
};
String.prototype.truncate = function truncate(length) {
    return _truncate(String(this), length);
};
String.prototype.trim = function trim(chars = "") {
    return _trim(String(this), chars);
};
String.prototype.trimEnd = function trimEnd(chars = "") {
    return _trimEnd(String(this), chars);
};
String.prototype.trimStart = function trimStart(chars = "") {
    return _trimStart(String(this), chars);
};
String.prototype.stripEnd = function stripEnd(suffix) {
    return _stripEnd(String(this), suffix);
};
String.prototype.stripStart = function stripStart(prefix) {
    return _stripStart(String(this), prefix);
};
if (typeof String.prototype.dedent === "undefined") {
    String.prototype.dedent = function dedent() {
        return _dedent(String(this));
    };
}
String.prototype.byteLength = function byteLength() {
    return _byteLength(String(this));
};
String.prototype.isAscii = function isAscii(printableOnly = false) {
    return _isAscii(String(this), printableOnly);
};
String.prototype.isEmoji = function isEmoji() {
    return _isEmoji(String(this));
};
//# sourceMappingURL=string.js.map